import useEffectOnce from '@app/hooks/useEffectOnce'
import track, { AnalyticsEventName } from '@app/utils/analytics'
import { showNewMessage } from '@app/utils/intercom'
import { Alert, AlertLink } from '@lokalise/louis'
import type { FC } from 'react'

type OtaUsageAboveLimitAlertProps = {
	usageLimit: number
	threshold: number
	percentageUsage: number
	totalTrafficInGiBs: number
	onClose: () => void
}

const OtaUsageAboveLimitAlert: FC<OtaUsageAboveLimitAlertProps> = ({
	usageLimit,
	percentageUsage,
	threshold,
	totalTrafficInGiBs,
	onClose,
}) => {
	const currentDate = new Date()
	const daysInCurrentMonth = new Date(
		currentDate.getFullYear(),
		currentDate.getMonth() + 1,
		0,
	).getDate()
	const overLimitGiBs = (totalTrafficInGiBs - usageLimit).toFixed(2)
	const message = `You're exceeding your ${usageLimit} GB OTA data allowance by ${overLimitGiBs} GB.`
	const eventProperties = {
		message,
		gb_limit: usageLimit,
		threshold,
		spent_traffic_percentage: Math.ceil(percentageUsage),
		spent_month_percentage: Math.ceil((currentDate.getDate() / daysInCurrentMonth) * 100),
	}

	useEffectOnce(() => {
		track(AnalyticsEventName.BANNER_DISPLAYED, eventProperties)
	})

	return (
		<Alert data-testid="otaUsageAboveLimitAlert" status="error" onClose={onClose}>
			{`${message} `}
			<AlertLink onClick={() => showNewMessage()}>Act now</AlertLink>
			{` and purchase more bundles to keep using Lokalise!`}
		</Alert>
	)
}

export default OtaUsageAboveLimitAlert
